import { useEasyModeContext } from '../../contexts/EasyModeContext';
import XButton from '../common/XButton';
import XInput from '../common/XInput';
import {
  defendantAddRowClasses,
  defendantCapHintClasses,
  defendantEntryClasses,
  defendantEntryHeaderClasses,
  defendantEntryTitleClasses,
  defendantFieldGridClasses,
  defendantHeaderClasses,
  defendantPanelClasses,
  defendantQuestionClasses,
  defendantSubtitleClasses
} from './easyModeClasses';

const EasyModeDefendantPanel = () => {
  const { defendantStep } = useEasyModeContext();
  const {
    isExpanded,
    toggleExpanded,
    entries,
    maxDefendants,
    canAddMore,
    handleChange,
    handleBlur,
    addDefendant,
    removeDefendant
  } = defendantStep;

  const isMultiple = maxDefendants > 1;

  return (
    <div className={defendantPanelClasses}>
      <div className={defendantHeaderClasses}>
        <span className={defendantQuestionClasses}>Know the defendant's details?</span>
        <XButton variant="link" onClick={toggleExpanded}>
          {isExpanded ? 'Hide' : 'Add Defendant'}
        </XButton>
      </div>

      {isExpanded && (
        <>
          <p className={defendantSubtitleClasses}>
            If the defendant's details are not in your uploaded documents, add them here. Anything you enter
            is kept and will not be overwritten unless the documents name the same defendant.
          </p>

          {entries.map((entry, index) => (
            <div key={entry.defendantId || index} className={defendantEntryClasses}>
              {isMultiple && (
                <div className={defendantEntryHeaderClasses}>
                  <span className={defendantEntryTitleClasses}>{`Defendant ${index + 1}`}</span>
                  {entries.length > 1 && (
                    <XButton variant="link" onClick={() => removeDefendant({ index })}>
                      Remove
                    </XButton>
                  )}
                </div>
              )}
              <div className={defendantFieldGridClasses}>
                <XInput
                  label="Defendant Name"
                  name="name"
                  value={entry.name}
                  onChange={(event) => handleChange({ index, field: event.target.name, value: event.target.value })}
                  onBlur={() => handleBlur({ index })}
                />
                <XInput
                  label="Insurance Company (optional)"
                  name="insuranceName"
                  value={entry.insuranceName}
                  onChange={(event) => handleChange({ index, field: event.target.name, value: event.target.value })}
                  onBlur={() => handleBlur({ index })}
                />
                <XInput
                  label="Claim Number (optional)"
                  name="claimNumber"
                  value={entry.claimNumber}
                  onChange={(event) => handleChange({ index, field: event.target.name, value: event.target.value })}
                  onBlur={() => handleBlur({ index })}
                />
                <XInput
                  label="Adjuster Name (optional)"
                  name="adjusterName"
                  value={entry.adjusterName}
                  onChange={(event) => handleChange({ index, field: event.target.name, value: event.target.value })}
                  onBlur={() => handleBlur({ index })}
                />
              </div>
            </div>
          ))}

          {canAddMore ? (
            <div className={defendantAddRowClasses}>
              <XButton variant="link" onClick={addDefendant}>
                Add another defendant
              </XButton>
            </div>
          ) : (
            isMultiple && (
              <p className={defendantCapHintClasses}>
                {`That is all ${maxDefendants} defendant(s) from Case Intake. Change the count on Step 1 to add more.`}
              </p>
            )
          )}
        </>
      )}
    </div>
  );
};

export default EasyModeDefendantPanel;
